import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';
import { chatFeatureKey } from '../key';

type ChatroomDetailQueryType = GenericDetailQueryKey;

export const getChatroomDetailQueryKey = (params: ChatroomDetailQueryType) =>
  generateDetailQueryKey({
    prefix: chatFeatureKey,
  })(params);
